const mobileMenuToggleBtns = document.querySelectorAll('[data-mobile-toggle-btn]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

export default function initMobileMenuToggle() {
    if (mobileMenuToggleBtns) {
        mobileMenuToggleBtns.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();

                if (!mobileMenu.classList.contains('mobile-menu-expanded')) {
                    mobileMenu.classList.add('mobile-menu-expanded');
                } else {
                    mobileMenu.classList.remove('mobile-menu-expanded');
                }
            });
        });
    }
}
